import React from 'react';
import {
    Chart as ChartJS,
    LineElement,
    PointElement,
    RadialLinearScale
} from 'chart.js';
import { Radar } from 'react-chartjs-2';

ChartJS.register(LineElement, PointElement, RadialLinearScale);

type RadarChartProps = {
    labels: string[],
    data: string[] | number[],
    min?: number,
    max?: number,
    stepSize?: number
};

function RadarChart({
    labels,
    data,
    min = 0,
    max = 100,
    stepSize = (max - min)/10
}: RadarChartProps) {
    return (
        <Radar
            width='100%'
            data={{
                labels: labels,
                datasets: [{
                    data: data,
                    borderColor: '#dd323a',
                    borderWidth: 3,
                    pointRadius: 0
                }]
            }}
            options={{
                maintainAspectRatio: false,
                scales: {
                    r: {
                        grid: {
                            circular: true,
                            color: '#ededed'
                        },
                        beginAtZero: true,
                        min: min,
                        max: max,
                        ticks: {
                            color: '#ededed',
                            font: {
                                size: 10
                            },
                            stepSize: stepSize
                        },
                        angleLines: {
                            display: false
                        },
                        pointLabels: {
                            color: '#828282',
                            font: {
                                size: 10
                            },
                            callback: (label, index) => {
                                let split = label.split(' ');
                                let temp = '';
                                let newLabel = [];
                                while (split.length > 0) {
                                    if (temp.length + split[0].length > 10) {
                                        newLabel.push(temp);
                                        temp = split.shift();
                                    }
                                    else {
                                        if (temp.length) temp += ' ';
                                        temp += split.shift();
                                    }
                                }
                                if (temp.length) newLabel.push(temp);

                                newLabel.push(`${data[index]}/${max}`);

                                return newLabel;
                            }
                        }
                    }
                }
            }}
        />
    );
}

export default RadarChart;